import type { Auth } from "../../store/ducks/auth/types";

type AccessIndicator = boolean | number | null | undefined;

export const isAccessEnabled = (indicator: AccessIndicator) =>
  indicator === true || indicator === 1;

export const canAccessStudentPortal = (auth?: Auth | null) =>
  isAccessEnabled(auth?.icAcessoPortalAluno);

export const canAccessAdminPanel = (auth?: Auth | null) =>
  isAccessEnabled(auth?.icAcessoPainelAdm);

export const getDefaultAdminPath = () => "/usuarios";

export const getDefaultAuthenticatedPath = (auth?: Auth | null) => {
  if (canAccessStudentPortal(auth)) return "/app";
  if (canAccessAdminPanel(auth)) return getDefaultAdminPath();
  return "/exit";
};
